import { connect } from 'react-redux';
import { exposActions } from '../../../../../redux/admin/expos/actions';
import PublishExpoModal from './index';

const mapDispatchToProps = {
  publishExpo: exposActions.publishExpo,
};

export default connect(null, mapDispatchToProps)(PublishExpoModal);
